export default {
  getSearch: () => {
    const search = JSON.parse(localStorage.getItem('searched')) || undefined;
    return search;
  },
};
